import angular from "angular";

import {
  Template,TemplateListItem,BusinessTemplates,
} from "@salaxy/core";

import { UiHelpers } from "../../services";
import { ApiCrudObjectController } from "../bases";

/**
 * Controller for template management.
 */
export class TemplateCrudController extends ApiCrudObjectController<Template, TemplateListItem> {
  isSaving: boolean;
  /**
   * For NG-dependency injection
   * @ignore
   */
  public static $inject = [
    "BusinessTemplates",
    "UiHelpers",
    "$location",
    "$routeParams"
  ];

  constructor(
    api: BusinessTemplates,
    uiHelpers: UiHelpers,
    $location: angular.ILocationService,
    $routeParams: any
  ) { // Dependency injection
    super(api, uiHelpers, $location, $routeParams);
  }

  /** Implements the getDefaults of ApiCrudObjectController */
  public getDefaults() {
    return {
      listUrl: this.listUrl || "/templates",
      detailsUrl: this.detailsUrl || "/templates/details/",
      oDataTemplateUrl: "salaxy-components/odata/lists/Templates.html",
      oDataOptions: {},
    };
  }

  /**
   * Select template.
   */
  public selectTemplate() {
    return this.uiHelpers.openEditDialog(
      "salaxy-components/modals/templates/TemplateSelect.html",     
      [],
      {
        title: "SALAXY.UI_Terms.select",
        options: null,
        okButtonText: "SALAXY.UI_Terms.ok",
        cancelButtonText: "SALAXY.UI_Terms.cancel",
      },"lg").then((result) => {
        if (result.action === "ok" && result.item.length > 0) {
          this.uiHelpers.showConfirm("SALAXY.UI_Terms.confirm",result.item[0].shortText + "\r\n" +result.item[0].data.description);
          //const loading = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait");        
          //loading.dismiss();
        }
      });
  }

}